import { trackGtm, trackYouLeadForm } from "./track-event"

// Inline newsletter form: fire the YouLead beacon and swap in a success
// message in place, without submitting. Kept as a dedicated handler because of this
// bespoke no-submit + localized-message behavior.
const NEWSLETTER_FORM_ID = "mc-embedded-subscribe-form"

const successMessage = (language) => {
  if (language === "pl") {
    return "Dziękujemy za zapisz do naszego newslettera."
  }

  if (language === "fr") {
    return "Merci pour votre inscription à notre newsletter!"
  }

  if (language === "de") {
    return "Vielen Dank für Ihre Anmeldung zu unserem Newsletter!"
  }

  return "Thank you for subscribing to our newsletter."
}

document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector(`#${NEWSLETTER_FORM_ID}`)

  if (!form) {
    return
  }

  const language = document.documentElement.lang || "PL"

  form.addEventListener("submit", (event) => {
    event.preventDefault()

    trackYouLeadForm(form.id)
    trackGtm("mailchimp.newsletter.submit")

    form.innerHTML = `<div id="mce-responses" class="clear">
      <div class="response" id="mce-success-response">${successMessage(language)}</div>
    </div>`
  })
})
